/**
 * ItemPicker — the public item selection UI: a quantity stepper per menu item.
 * Respects each item's optional maxQty and shows prices when enabled.
 */
import React from 'react';

export default function ItemPicker({ items, quantities, onChange, showPrices }) {
  const step = (it, delta) => {
    const cur = Number(quantities[it.id]) || 0;
    const max = it.maxQty ? Number(it.maxQty) : Infinity;
    let next = cur + delta;
    if (next < 0) next = 0;
    if (next > max) next = max;
    onChange(it.id, next);
  };

  return (
    <div className="evf-items">
      {items.map((it) => {
        const qty = Number(quantities[it.id]) || 0;
        const atMax = it.maxQty ? qty >= Number(it.maxQty) : false;
        return (
          <div key={it.id} className={`evf-item${qty > 0 ? ' is-on' : ''}`}>
            <div className="evf-item__info">
              <div className="evf-item__name">
                {it.name || 'Item'}
                {showPrices && it.price !== '' && it.price != null && Number(it.price) > 0 ? (
                  <span className="evf-item__price">${Number(it.price).toFixed(2)}</span>
                ) : null}
              </div>
              {it.description ? <div className="evf-item__desc">{it.description}</div> : null}
            </div>
            <div className="evf-stepper">
              <button type="button" className="evf-step" onClick={() => step(it, -1)}
                disabled={qty === 0} aria-label={`Decrease ${it.name}`}>−</button>
              <span className="evf-qty">{qty}</span>
              <button type="button" className="evf-step" onClick={() => step(it, 1)}
                disabled={atMax} aria-label={`Increase ${it.name}`}>+</button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
